import { createHttpCatalogRepository } from "@/lib/httpCatalogRepository";
import { mockCatalogRepository } from "@/lib/mockCatalogRepository";
import type { CatalogRepository } from "@/types/catalog";

/**
 * アプリが使う作品データ取得層の入口。
 *
 * 既定はデモデータ（MockCatalogRepository）。
 * 本番APIが用意できたら setCatalogRepository(createHttpCatalogRepository(url)) に差し替えるだけで、
 * 検索・ランキング・ファセットのUIはそのまま動く。
 */

let activeRepository: CatalogRepository = mockCatalogRepository;

export function getCatalogRepository(): CatalogRepository {
  return activeRepository;
}

export function setCatalogRepository(repository: CatalogRepository): void {
  activeRepository = repository;
}

/** 検索APIのベースURLが設定されている場合のみ HTTP 実装へ切り替える */
export function configureCatalogFromEnv(): CatalogRepository {
  const baseUrl = (import.meta.env.VITE_PUBLIC_CATALOG_API_URL as string | undefined) ?? "";
  if (baseUrl.trim()) {
    activeRepository = createHttpCatalogRepository(baseUrl.trim());
  }
  return activeRepository;
}

export function resetCatalogRepository(): void {
  activeRepository = mockCatalogRepository;
}

export type { CatalogRepository } from "@/types/catalog";